<div class="error">
  <span class="error__title">{{'An unexpected error occurred.' | translate}}</span>
  <span class="error__description">{{'Try again later!' | translate}}</span>
</div>
